import { parseErrors, Toast } from 'helpers';
import { getServiceProducts, patchServiceProducts } from 'queries';
import { useMutation, useQuery } from '@tanstack/react-query';

export function useServiceProducts(serviceId?: string | number) {
  const {
    data: serviceProducts,
    refetch,
    isLoading: isFetching,
  } = useQuery(['service', serviceId!, 'products'], ({ queryKey }) => getServiceProducts(queryKey[1]), {
    enabled: !!serviceId,
  });

  type PatchArgs = Parameters<typeof patchServiceProducts>;
  const {
    mutate,
    isLoading: isUpdating,
    error: updateError,
  } = useMutation(['service', serviceId, 'products', 'update'], (vars: PatchArgs) => patchServiceProducts(...vars), {
    onSettled: () => {
      refetch();
    },
    onError: (error: unknown) => {
      console.error(error);
      Toast.show({ type: Toast.Type.Error, description: parseErrors(error)[0] || 'Error updating products' });
    },
  });

  const isLoading = isFetching || isUpdating;

  const updateProducts =
    typeof serviceId !== 'undefined'
      ? function updateProducts(products: PatchArgs[1]) {
          mutate([serviceId, products]);
        }
      : undefined;

  return [serviceProducts, isLoading, updateProducts, isUpdating, updateError] as const;
}
